const PRODUCT_ID = document?.querySelector('body').getAttribute('product-id');

if (PRODUCT_ID) {
  const ASSET_ID_BY_PRODUCT_ID = {
    "8406251733170": "ce73eea8-dbd4-47b8-9a0d-dc91afe6a623", //Balance Mid-Back Chair - Basic (5694B)
    "8406252290226": "d8fad74b-5085-4c81-be48-eb65797e0136", //Balance Mid-Back Chair (5694)
    "8406257729714": "7b31449b-b2a2-480c-a74f-1650ed5f4c2a", //Lifestyles Mid-Back Chair (8694)
    "8416383303858": "10e28179-ed8d-49c8-b03e-5bfe17cadb79", // Lifestyles Mid-Back Chair - Basic (8694B)
    "8416618545330": "d1f37e23-4c16-4402-9824-5ff75f198547", //Brezza Mesh-Back Chair (180)
    "8418445033650": "5a579945-f403-473c-a46f-4a439fbf9e78", //Brezza Mesh-Back Chair - Basic (180B)
    "8406257828018": "e8740a14-122b-44b7-b569-e817b442f4bf", //Palisades Conference Mid-Back Chair (4610)
    "8406257762482": "25d717f4-59b9-4096-9350-8c0e96fff301", //Palisades Conference Mesh-Back Chair (4010)
    "8415751471282": "ebb6c742-bfb5-4187-bf0c-e35802edc3ac", //Ultimate Executive™ Mid-Back Chair (2490)
    "8406257336498": "a2748d02-c6a5-481f-b623-f9d255afd71c", //Legacy Executive High-Back Chair (900)
    "8402301419698": "7268bb7e-69d8-4980-9ab6-e4bbac3399f4", //Ultimate Executive™ High-Back Chair (2390)
  }

  const MAP_TABLE_ID_BY_PRODUCT_ID = {
    "8406251733170": "8926a362-445b-4262-a607-95150e0d1cf6", //Balance Mid-Back Chair - Basic (5694B)
    "8406252290226": "8926a362-445b-4262-a607-95150e0d1cf6", //Balance Mid-Back Chair (5694)
    "8406257729714": "d23360bc-1021-4df4-a259-8847214fe06e", //Lifestyles Mid-Back Chair (8694)
    "8416383303858": "d23360bc-1021-4df4-a259-8847214fe06e", // Lifestyles Mid-Back Chair - Basic (8694B)
    "8416618545330": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee", //Brezza Mesh-Back Chair (180)
    "8418445033650": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee", //Brezza Mesh-Back Chair - Basic (180B)
    "8406257828018": "96cacf14-b094-4098-acde-218a7119fcd6", //Palisades Conference Mid-Back Chair (4610)
    "8406257762482": "96cacf14-b094-4098-acde-218a7119fcd6", //Palisades Conference Mesh-Back Chair (4010)
    "8415751471282": "f441c37a-fd2a-42c5-b98e-3173d5889ca3", //Ultimate Executive™ Mid-Back Chair (2490)
    "8406257336498": "d8881934-7bc2-4290-afb2-e4dbe18f8346", //Legacy Executive High-Back Chair (900)
    "8402301419698": "e2532550-5ed7-4c42-8461-550cc675b564", //Ultimate Executive™ High-Back Chair (2390)
  }

  window.assetId = ASSET_ID_BY_PRODUCT_ID[`${PRODUCT_ID}`];
  window.mapTableId = MAP_TABLE_ID_BY_PRODUCT_ID[`${PRODUCT_ID}`];
}


